import React from 'react'
import Layout from './layout/layout'
function Aboutus() {
  return (
    <Layout>
      <h1>hi hello welcome to the about us page</h1>
    </Layout>
  )
}

export default Aboutus
